<template>
  <div class="modal-body">
    <table class="table table-bordered ragistration" style="border-collapse:collapse;">
        <tr>
            <th>氏名</th>
            <td>{{result.userName}}</td>
        </tr>
        <tr>
            <th>現住所</th>
            <td>
              <tr>〒 {{result.currentPostalCode}}</tr>
              <tr>{{result.currentAddress}}</tr>
            </td>
        </tr>
        <tr>
            <th>住民票住所</th>
            <td>
              <tr>〒 {{result.residenceCardPostalCode}}</tr>
              <tr>{{result.residenceCardAddress}}</tr>
            </td>
        </tr>
        <tr>
            <th>携帯電話</th>
            <td>{{result.tel1}}</td>
        </tr>
        <tr>
            <th>携帯メールアドレス</th>
            <td>{{result.mail}}</td>
        </tr>
        <tr>
            <th>緊急連絡先　番号/宛先</th>
            <td>{{result.tel2}} / {{result.destination}}</td>
        </tr>
        <tr>
            <th>通勤交通機関及び交通費</th>
            <td class="m-0 p-0">
              <tr class="row m-0">
                <th>バス</th>
                <td class="m-0 p-0">
                  <tr class="row m-0">
                    <th class="col-6">バス会社名</th>
                    <td class="col-6">{{result.busCompanyName}}</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">自宅最寄停留所</th>
                    <td class="col-6">{{result.busStart}}</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">駅最寄停留所</th>
                    <td class="col-6">{{result.busEnd}}</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">片道</th>
                    <td class="col-6">{{result.busOneWayExpense}}円</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">1ヶ月定期代</th>
                    <td class="col-6">{{result.busMonthlyExpense}}円</td>
                  </tr>
                </td>
              </tr>
              <tr>
                <th>鉄道</th>
                <td class="m-0 p-0">
                  <tr class="row m-0">
                    <th class="col-6">自宅最寄駅</th>
                    <td class="col-6">{{result.trainStartStation}}</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">会社最寄駅</th>
                    <td class="col-6">{{result.trainEndStation}}</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">使用路線</th>
                    <td class="col-6">{{result.trainRoute}}</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">片道</th>
                    <td class="col-6">{{result.trainOneWayExpense}}円</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">1ヶ月定期代</th>
                    <td class="col-6">{{result.trainMonthlyExpense}}円</td>
                  </tr>
                </td>
              </tr>
              <tr>
                <th>合計</th>
                <td class="m-0 p-0">
                  <tr class="row m-0">
                    <th class="col-6">片道</th>
                    <td class="col-6">{{result.sumOneWayExpense}}円</td>
                  </tr>
                  <tr class="row m-0">
                    <th class="col-6">1ヶ月定期代</th>
                    <td class="col-6">{{result.sumMonthlyExpense}}円</td>
                  </tr>
                </td>
              </tr>
            </td>
        </tr>
        <tr>
            <th>給与振込先</th>
            <td class="m-0 p-0">
              <tr class="row m-0">
                <th class="col-6">銀行名/銀行番号</th>
                <td class="col-6">{{result.bankName}}/{{result.bankNumber}}</td>
              </tr>
              <tr class="row m-0">
                <th class="col-6">支店名/支店番号</th>
                <td class="col-6">{{result.bankBranchName}}/{{result.bankBranchNumber}}</td>
              </tr>
              <tr class="row m-0">
                <th class="col-6">預金タイプ</th>
                <td class="col-6">{{result.bankAccountType}}</td>
              </tr>
              <tr class="row m-0">
                <th class="col-6">口座番号（7ケタ）</th>
                <td class="col-6">{{result.bankAccountNumber}}</td>
              </tr>
              <tr class="row m-0">
                <th class="col-6">口座名義人（カナ）</th>
                <td class="col-6">{{result.bankAccountHolder}}</td>
              </tr>
            </td>
        </tr>
        <tr v-if="loginUser.userId == result.userId || hasAnyRole('ROLE_ADMIN')">
            <th>基礎年金番号</th>
            <td>{{result.basicPensionNumber}}</td>
        </tr>
        <tr v-if="loginUser.userId == result.userId || hasAnyRole('ROLE_ADMIN')">
            <th>被保険者番号</th>
            <td>{{result.insuredNumber}}</td>
        </tr>
        <tr v-if="loginUser.userId == result.userId || hasAnyRole('ROLE_ADMIN')">
            <th>個人番号</th>
            <td>{{result.personalNumber}}</td>
        </tr>
    </table>
    <img v-if="result.imageUrl" class="card-img-top icon" :class="'byteImage' + result.id" />
  </div>
</template>

<style scoped>
.icon {
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
}
.ragistration th {
  background-color: #f0f0f0;
}
</style>

<script>
import UserAPI from '../../../api/user-api'

export default {
  name: "user-work-registration-view",
  components: {
  },
  props: {
    result: Object,
    loginUser: Object
  },
  data() {
    return {
    }
  },
  watch: {
    'result': function (val) {
        this.download()
    },
  },
  mounted () {
    this.$root.$refs.loading.$data.show = false
    if(this.result.imageUrl != null){
      this.download()
    }
  },
  methods: {
    setTab(index) {
      this.tab = index;
    },
    // 前の画面へ
    goBack () {
        this.$root.$refs.loading.$data.show = true
        this.$router.go(-1)
    },
    goWorkRegistrarionCreate(userId) {
        this.$router.push('/admin/user/work-registration/edit/' + userId)
    },
    goWorkRegistrarionEdit(userId, id) {
        $(".close").click()
        this.$root.$refs.loading.$data.show = true
        this.$router.push('/admin/user/work-registration/edit/' + userId + "?id=" + id)
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    download(){
        UserAPI.downloadUserWorkRegistration(this.result.userId, this.result.id)
            .then(res => {
              this.$nextTick(function() {
                $(".byteImage" + this.result.id).each(function(index, elm){
                  elm.src = res
                })
              })
            })
            .catch(err => {
                console.error(err)
            }) 
    }
  },
  computed: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/common/user/UserWorkRegistrationView.vue